<template>
  <div class="form__main">
    <ContactsTable
      :outerFilters="outerFilters"
      hideControls
      editable
      hideSearch
      insideCampaign
      :campaignId="campaignId"
      :showSelect="false"
      :insideModal="isModal"
      :teamFilterOff="teamFilterOff"
    />
  </div>
</template>

<script>
import ContactsTable from '@/views/contacts/components/ContactsTable';

export default {
  name: 'GroupContacts',
  components: {
    ContactsTable,
  },
  props: {
    group: {
      type: Object,
      default: () => ({}),
    },
    isModal: Boolean,
    teamFilterOff: Boolean,
    additionalFilters: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    campaignId() {
      return this.$route?.params?.campaignId || '';
    },
    outerFilters() {
      return {
        ...this.group.filters,
        ...this.additionalFilters,
      };
    },
  },
};
</script>
